<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
        <div>
          <p class="fs-16 fs_14ForMobile font_regular">Create Announcement</p>
         </div>
         <div class="popup-close">
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
      
      <div class="popup-heading" *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
        <div>
          <p class="fs-16 fs_14ForMobile font_regular">Announcement Preview</p>
         </div>
         <div class="popup-close">
          <button class="downloadBtn" (click)="onClickDownlaodAnnouncement('getAnnouncement')">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>Download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
    </ion-col> 
  </ion-row>
 
<div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
  <ion-row class="verticle-center">
    <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
      <div class="fs-14 fs_12ForMobile font_semibold">Announcement Name:</div>
    </ion-col>
    <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
      <div>
        <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
          <input matInput  placeholder="Type here" [(ngModel)]="AnnouncementName" (ngModelChange)="isInvalidAnnouncement()">
        </mat-form-field>
      <div *ngIf="isInvalidAnnouncementName" class="fs-14 fs_12ForMobile red mt-5">Enter Announcement Name</div>
      </div>
    </ion-col>
  </ion-row>

  <ion-row class="verticle-center">
    <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
      <div class="fs-14 fs_12ForMobile font_semibold">Subject:</div>
    </ion-col>
    <ion-col size-sm="12" size-md="8" size-lg="8" size-xs="12">
      <div>
        <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
          <input matInput  placeholder="Type here" [(ngModel)]="AnnouncementSubject" (ngModelChange)="isInvalidAnnouncement()">
        </mat-form-field>
      <div *ngIf="isInvalidAnnouncementSubject" class="fs-14 fs_12ForMobile red mt-5">Enter Announcement Subject</div>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
      <div>
        <button type="button" class="postBtn" (click)="onClickSaveAnnouncement()">Post</button>
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col>
      <div class="mt-20">
        <angular-editor [placeholder]="'Enter Announcement Here...'"  [config]="editorConfig"
        [(ngModel)]="AnnouncementDescription">
      </angular-editor>
      </div>
      <div *ngIf="isInvalidAnnouncementDescription" class="fs-14 fs_12ForMobile red mt-5">Enter Announcement Description</div>
    </ion-col>
  </ion-row>
</div>

<div *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
  <div class="cardBox mt-10" id="getAnnouncement">
    <div class="AnnouncementCardEmployeeView">
      <div class="mt-10"><span class="fs-bold">Announcement Name:-</span> {{AnnouncementName}}</div>
      <div class="mt-10"><span class="fs-bold">Subject:-</span> {{AnnouncementSubject}}</div>
      <div class="mt-10">
        <p [innerHTML]="AnnouncementDescription"></p>
      </div>
    </div>
  </div>
</div>
  </div>